import { Flex, FlexProps } from '@chakra-ui/react';
import { FC } from 'react';

export const SideBarMessage: FC<FlexProps> = ({ children }) => {
  return (
    <Flex justifyContent="center" h="full" alignItems="center" p={8}>
      {children}
    </Flex>
  );
};
